let OpenDayInfo = {
    Description: "Organizată pentru prima dată în cadrul evenimentului, Open Day reprezintă o zi diferită de restul săptămânii deoarece înglobează o serie de webinarii a căror tematică e reprezentată de start-ups. Într-un discurs interactiv de maxim o oră, speakerii noștri vor răspunde unor întrebări pregătite de noi care țin de experiența lor personală în domeniul afacerilor și unora generale despre aria în care activează. Orice participant al acestei ediții se poate înscrie și sau numai la Open Day, aceasta urmând să aibă loc în ziua de duminică, 13 septembrie.",
    Speeches: [
        {
            Title: "Urmeaza sa fie anuntat",
            Period: "10:00 - 11:00",
            Description: "Lorem ipsum dolorlore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla "
        },
        {
            Title: "Urmeaza sa fie anuntat",
            Period: "11:00 - 12:00",
            Description: "Lorem ipsum dolorlore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla "
        },
        {
            Title: "Urmeaza sa fie anuntat",
            Period: "12:00 - 13:00",
            Description: "Lorem ipsum dolorlore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla "
        },
        {
            Title: "Urmeaza sa fie anuntat",
            Period: "13:30 - 14:30",
            Description: "Lorem ipsum dolorlore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla "
        },
        {
            Title: "Urmeaza sa fie anuntat",
            Period: "14:30 - 15:30",
            Description: "Lorem ipsum dolorlore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla "
        },
        {
            Title: "Urmeaza sa fie anuntat",
            Period: "15:30 - 16:30",
            Description: "Lorem ipsum dolorlore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla "
        },
        {
            Title: "Urmeaza sa fie anuntat",
            Period: "17:00 - 18:00",
            Description: "Lorem ipsum dolorlore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla "
        },
        {
            Title: "Urmeaza sa fie anuntat",
            Period: "18:00 - 19:00",
            Description: "Lorem ipsum dolorlore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla "
        },
        {
            Title: "Urmeaza sa fie anuntat",
            Period: "19:00 - 20:00",
            Description: "Lorem ipsum dolorlore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla "
        },
    ]
}

export default OpenDayInfo;